function truncateHTMLString(html: string, limit: number) {
    const container = document.createElement('div');
    container.innerHTML = html;

    let charCount = 0;
    let stop = false;

    function traverse(node) {
        if (stop) {
            node.remove();
            return;
        }

        if (node.nodeType === Node.TEXT_NODE) {
            if (charCount + node.textContent.length > limit) {
                node.textContent = node.textContent.slice(0, limit - charCount) + '...';
                stop = true;
            } else {
                charCount += node.textContent.length;
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            Array.from(node.childNodes).forEach(traverse);
        }
    }

    traverse(container);
    return container.innerHTML;
}


export function truncateText(elementToTruncate: HTMLElement) {
    const limit = parseInt(elementToTruncate.getAttribute('data-truncate'));
    const originalHtml = elementToTruncate.innerHTML;
    const truncatedHtml = truncateHTMLString(elementToTruncate.innerHTML, limit);
    if (originalHtml.length > limit) {
        elementToTruncate.innerHTML = truncatedHtml;
        const showMoreButton = document.querySelector(`[data-truncate-show-btn=${elementToTruncate.getAttribute('id')}]`);
        const showLessButton = document.querySelector(`[data-truncate-hide-btn=${elementToTruncate.getAttribute('id')}]`);
        showMoreButton?.addEventListener('click', () => {
            elementToTruncate.innerHTML = originalHtml;
            showMoreButton.setAttribute('hidden', 'true');
            showLessButton.removeAttribute('hidden');
        });
        
        showLessButton?.addEventListener('click', () => {
            elementToTruncate.innerHTML = truncatedHtml;
            showLessButton.setAttribute('hidden', 'true');
            showMoreButton.removeAttribute('hidden');
        });
    } 
}
